import { Layout } from "@/components/Layout";
import { SEO } from "@/components/SEO";
import { Mail, Phone, MapPin } from "lucide-react";
import { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://link.msgsndr.com/js/form_embed.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Layout>
      <SEO
        title="Contact Us | Automation & AI for Small Businesses in Edmonton"
        description="Contact Missed Call Rescue today. We provide premier automation and AI solutions for small businesses in Edmonton. Get in touch to learn more."
        canonical="/contact"
      />
      <section className="bg-primary pt-20 pb-16 text-primary-foreground">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Contact Missed Call Rescue — AI Solutions for Edmonton Small Businesses</h1>
          <p className="text-xl text-primary-foreground/80 max-w-2xl mx-auto">
            Ready to rescue your missed calls? Contact our team today to get started or learn more.
          </p>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 bg-white rounded-2xl shadow-sm overflow-hidden border border-slate-100">
            
            {/* Contact Information */}
            <div className="lg:col-span-2 bg-slate-900 text-white p-10 flex flex-col justify-between relative overflow-hidden">
              <div className="absolute top-0 right-0 -mt-20 -mr-20 w-64 h-64 bg-primary rounded-full opacity-50 blur-3xl"></div>
              <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-64 h-64 bg-secondary rounded-full opacity-30 blur-3xl"></div>
              
              <div className="relative z-10">
                <h2 className="text-2xl font-bold mb-2">Contact Information</h2>
                <p className="text-slate-400 mb-10">Fill out the form and our team will get back to you within 24 hours.</p>

                <div className="space-y-8">
                  <div className="flex items-start gap-4">
                    <Phone className="h-6 w-6 text-emerald-400 shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-lg">Phone</h3>
                      <p className="text-slate-400 flex flex-col gap-1">
                        <span>Toll-free: <a href="tel:1-855-780-3522" className="hover:text-emerald-400 transition-colors">1-855-780-3522</a></span>
                        <span>Local: <a href="tel:780-237-6933" className="hover:text-emerald-400 transition-colors">780-237-6933</a></span>
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <Mail className="h-6 w-6 text-emerald-400 shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-lg">Email</h3>
                      <a href="mailto:missedcallrescuecanada@gmail.com" className="text-slate-400 hover:text-emerald-400 transition-colors">missedcallrescuecanada@gmail.com</a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <MapPin className="h-6 w-6 text-emerald-400 shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-lg">Office</h3>
                      <p className="text-slate-400">Edmonton, Alberta<br/>Canada T5L2C2</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-3 p-10">
              <h2 className="text-2xl font-bold text-slate-900 mb-6">Send us a message</h2>
              
              <iframe
                src="https://api.leadconnectorhq.com/widget/form/1NWv7ewLc6LLhhRE5VXD"
                style={{ width: '100%', height: '100%', border: 'none', minHeight: '743px', borderRadius: '8px' }}
                id="inline-1NWv7ewLc6LLhhRE5VXD" 
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Form 1"
                data-height="743"
                data-layout-iframe-id="inline-1NWv7ewLc6LLhhRE5VXD"
                data-form-id="1NWv7ewLc6LLhhRE5VXD"
                title="Contact Form"
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
